<svg
  width="38"
  height="15"
  viewBox="0 0 38 15"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
  class="text-highlight-foreground"
>
  <path
    d="M1.90625 13.1788C1.90625 9.75829 1.90625 6.33779 1.90625 2.91729C1.90625 1.77496 2.34525 2.90445 2.56828 3.38768C3.58365 5.58763 4.5253 7.8361 5.66938 9.97316C5.87848 10.3637 8.26219 14.9967 8.49173 13.5621C9.03002 10.1978 9.43251 6.93535 9.43251 3.52705C9.43251 0.697332 9.45757 3.81893 9.76353 5.04276C9.9088 5.62386 10.8986 11.785 11.6277 11.785C11.7826 11.785 12.551 3.85059 12.7253 3.05666C12.7833 2.79242 13.0187 1.13438 13.3524 1.00088C13.499 0.942246 14.4077 3.84217 14.45 3.98002C15.3651 6.96044 15.5152 10.4323 16.6626 13.3007C16.693 13.3767 16.966 11.3284 16.9762 11.0882C17.0669 8.9565 17.5662 6.8906 17.8299 4.78143C17.8388 4.71021 18.1279 2.27501 18.5267 3.10893C19.3901 4.91404 19.7969 10.9253 22.2376 11.3321C23.7188 11.5789 23.0176 2.5267 24.2411 3.8058C25.6068 5.2336 26.5022 7.3641 27.5513 9.03238C27.9982 9.74298 29.0658 12.2627 29.1715 10.0951C29.2581 8.3204 29.113 6.53831 29.2064 4.76401C29.2771 3.41937 29.563 2.81173 30.2691 4.22393C30.9315 5.54877 31.4148 7.34249 32.5688 8.3355C33.6855 9.29635 33.8461 7.35206 34.0497 6.62815C34.761 4.09888 34.9731 6.16364 36.088 6.9069"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
